import React from 'react'
import { AlertTriangle } from "lucide-react";


const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <AlertTriangle className="w-16 h-16 text-red-500 mb-4" />
      <h1 className="text-2xl font-semibold mb-2">Something went wrong</h1>
    </div>
  )
}

export default NotFound